import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ReadingModes from "./components/ReadingModes";
import ReadingGuide from "./components/ReadingGuide";
import Tips from "./components/Tips";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ReadingModes />
        <ReadingGuide />
        <Tips />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}